
import React from 'react';

interface InstructionsOverlayProps {
  isEditable: boolean;
}

export const InstructionsOverlay = ({ isEditable }: InstructionsOverlayProps) => {
  return (
    <div 
      style={{ width: '200px', height: '100px' }} 
      className="absolute top-4 right-4 z-10 bg-black/80 text-white px-4 py-2 rounded-lg text-xs flex items-center justify-center text-center"
    >
      Instructions: {isEditable ? 
        "Drag and draw the reporting lines between role nodes. Double-click on the role nodes to edit and change the role titles" : 
        "This organization structure is no longer editable"
      }
    </div>
  );
};
